import { IBundleProduct, IBundleProductConfiguration, IBundleProductPrice, IBundleSingleProduct } from "./types";
import BundleProductPriceFactory from "../../../factories/manhattan/bundle/BundleProductPriceFactory";
import BundleSingleProductFactory from "../../../factories/manhattan/bundle/BundleSingleProductFactory";

export default class BundleProduct implements IBundleProduct {

  id: number;
  isMaster: boolean;
  useOriginalPrices: boolean;
  bundleProductConfigurations: any[];
  bundleProductPrices: IBundleProductPrice[];
  product: IBundleSingleProduct;

  constructor(
    id: number,
    isMaster: boolean,
    useOriginalPrices: boolean,
    bundleProductConfigurations: IBundleProductConfiguration[],
    bundleProductPrices: IBundleProductPrice[],
    product: IBundleSingleProduct
  ) {
    this.id = id;
    this.isMaster = isMaster;
    this.useOriginalPrices = useOriginalPrices;
    this.bundleProductConfigurations = bundleProductConfigurations;
    this.bundleProductPrices = [];
    bundleProductPrices.forEach((bundleProductPrice: IBundleProductPrice) => {
      this.bundleProductPrices.push(BundleProductPriceFactory.create(bundleProductPrice));
    });

    this.product = BundleSingleProductFactory.create(product);
  }

}
